export const APIURLLEGALES = process.env.REACT_APP_API_URL
export const APIURLREINGENIERIALEGALES = process.env.REACT_APP_API_REING_URL
export const APIURLSEGURIDAD= process.env.REACT_APP_API_SEGURIDAD
export const TOKENSEGURIDADAPI = process.env.REACT_APP_API_REACT_TOKEN
export const TOKENSEGURIDADAPIREING = process.env.REACT_APP_API_REING_TOKEN
export const APIURLDIGITALIZACIONTHUBAN = process.env.REACT_APP_API_THUBANURL